import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

export const travellerJourneyListLocale = {
  en: {
    setCustomName: 'Set custom name',
    profile: 'Traveller profile',
    journeys: 'Journeys',
    travellers: 'Travellers',
    journeyFields: 'Journey fields',
    fields: 'Fields',
    settings: 'Settings',
    overview: 'Overview',
    addTraveller: 'Add to journey',
    openJourneyBuilder: 'Open Journey Builder',
    details: 'Details',
    noPublishedJourneyTooltip: 'You need to publish the journey before adding travellers',
    notifications: 'Notifications',
    notifyOnError: 'Errors',
    notifyOnCompletion: 'Journey completion',
    notifyDescription: 'Choose the events you want to get email notifications for in this Journey.',
    notificationUpdateFailed: 'Failed to update notification settings',
    nrSelected: '{number} Selected',
    startJourney: 'Start journey',
    deleteTravellers: 'Remove travellers from journey',
    deleteBulkTitle: 'Remove traveller/s',
    bulkDeleteDescription:
      'Are you sure you want to remove the following travellers from this journey? All journey details and progress will be lost',
    resetBulkTitle: 'Reset journey/s',
    reset: 'Reset',
    bulkResetDescription:
      "Are you sure you want to reset these travellers journey? The journey will be reset to it's initial state and all progress will be lost",
    pauseJourney: 'Pause journey',
    resumeJourney: 'Resume journey',
    resetJourney: 'Reset journey',
    startBulkTitle: 'Start journey/s',
    bulkStartDescription: 'Start the following travellers journey/s',
    start: 'Start',
    pauseBulkTitle: 'Pause journey/s',
    bulkPauseDescription: 'Pause the following travellers journey/s',
    pause: 'Pause',
    resumeBulkTitle: 'Resume journey/s',
    bulkResumeDescription: 'Resume the following travellers journey/s',
    resume: 'Resume',
    travellersSelected: 'Traveller/s Selected',
    notStarted: 'Not started',
    inProgress: 'In progress',
    paused: 'Paused',
    completed: 'Completed',
    areYouSureRemove:
      "Are you sure you want to delete this field from the journey? This change will affect all travellers regardless of their journey state ('Not started', 'In progress', 'Completed').",

    pageSelected: 'All {count} Travellers on page selected',
    selectAllTravellers: 'Select all {count}',
    allSelected: 'All {count} Travellers selected',
    clearSelection: 'Clear selection',

    startJourneyInfo: 'Start journey',
    waitingToBeStarted: 'Waiting to be started',
    nextUp: 'Next up',
    remaining: 'Remaining',
    emptyContent: 'There are no travellers currently in this journey',
    emptyHeader: 'No travellers in journey',
    openBuilder: 'Open builder',

    phone: 'Phone',
    status: 'Status',
    email: 'Email',
    name: 'Name',
    remove: 'Remove',
    progress: 'Progress',
    error: 'Error',
    warning: 'Warning',
    noIssues: 'No issues',
    issues: 'Issues',

    not_started: 'Not started',
    in_progress: 'In progress',
    dates: 'Dates',

    date_started: 'Started journey',
    date_modified: 'Last modified',
    date_created: 'Created date',
    date_completed: 'Completed journey',
    action_date_completed: 'Date completed',
    action_status: 'Status',

    action_status_completed: 'Completed',
    action_status_in_progress: 'In progress',
    action_status_waiting_to_be_started: 'Waiting to be started',
    action_status_halted: 'Halted',
    action_status_upcoming: 'Upcoming',
    action_status_skipped: 'Skipped',

    actionFields: 'Action fields',
    customName: 'Set custom name',
    travellerEdited: 'Traveller updated successfully',
    removeField: 'Remove field',
    addToJourney: 'Add to journey',
    noDescription: 'No description',
    columnLoadError: 'Failed to load column data.',
  },
};

export const useTravellerJourneyListTranslate = () => {
  return useScopedTranslate(travellerJourneyListLocale);
};

export const { t } = getScopedTranslate(travellerJourneyListLocale);
